var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:_vm.classObject},[(_vm.classObject.darkened)?_c('div',{staticClass:"overlay__message"},[_c('svgicon',{staticClass:"overlay__icon",attrs:{"icon":"loading","width":"64","height":"64"}}),(_vm.showMessage)?_c('p',[_vm._v("Your results are loading, Please Wait...")]):_vm._e()],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }